import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  root: function root() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      height: 100%;\n      overflow: hidden;\n      position: relative;\n    "])));
  },
  inner: function inner() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      margin-bottom: -1px;\n      max-height: 100%;\n\n      /* IE sometimes enabled scroll: http://codepen.io/anon/pen/RRrLNX */\n      padding-bottom: 1px;\n      overflow-y: scroll;\n    "])));
  },
  scroll: function scroll() {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      position: absolute;\n      right: 2px;\n      transition: width 0.2s;\n      width: 4px;\n      z-index: 200;\n\n      &::after {\n        background: #b7b7b7;\n        border-radius: 5px;\n        bottom: 1px;\n        content: '';\n        display: block;\n        left: 0;\n        position: absolute;\n        right: 0;\n        top: 1px;\n      }\n    "])));
  },
  scrollHover: function scrollHover() {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      width: 10px;\n    "])));
  },
  scrollInvert: function scrollInvert() {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      &::after {\n        background: #ccc;\n        background: rgba(255, 255, 255, 0.5);\n      }\n    "])));
  }
});